import { createSlice } from '@reduxjs/toolkit';

import { UserLoginAttempt } from '@dill/dill-shared';
import {
  getSupplierPendingUserLoginAttemptsCountExtraReducer,
  getSupplierUserLoginAttemptsExtraReducer,
  rejectUserLoginAttemptExtraReducer,
} from '../reducers/userLoginAttemptsReducers';

export interface UserLoginAttemptsInitialState {
  loadingList: string[];
  error: string | null;
  userLoginAttempts: UserLoginAttempt[];
  supplierPendingUserLoginAttemptsCount: number;
}

const initialState: UserLoginAttemptsInitialState = {
  loadingList: [],
  error: null,
  userLoginAttempts: [],
  supplierPendingUserLoginAttemptsCount: 0,
};

export const userLoginAttemptsSlice = createSlice({
  name: 'userLoginAttempts',
  initialState,
  reducers: {
    resetUserLoginAttemptsRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierUserLoginAttemptsExtraReducer(builder);
    getSupplierPendingUserLoginAttemptsCountExtraReducer(builder);
    rejectUserLoginAttemptExtraReducer(builder);
  },
});

export const { resetUserLoginAttemptsRootState } = userLoginAttemptsSlice.actions;
